module.exports = new __parcel__URL__("map-dark.0d1c457e.svg").toString();